<template>
    <label class="inline-flex items-center">
        <input
            type="radio"
            class="form-radio"
            :value="label"
            :name="name"
            v-model="radioButtonValue"
        />
        <span class="ml-2 text-gray-600">{{ label }}</span>
    </label>
</template>

<script>
export default {
    props: {
        label: {
            type: String
        },
        name: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: true,
            default: ""
        }
    },
    data() {
        return {
            focused: false
        };
    },

    computed: {
        radioButtonValue: {
            get: function() {
                return this.value;
            },
            set: function() {
                this.$emit("change", this.label);
            }
        }
    }
};
</script>

<style></style>
